import React from "react";
import Modal from "../../assets/components/ModalComonent";

const Awards = ({ show, handleClose }) => {
  const awardsDialog = (
    <>
      <div className="w-100">
        <p className="font-weight-bold text-center blueColor">جوایز ماهانه</p>
        <div className="d-flex justify-content-center">
          <p className="mb-2">⌚ ساعت هوشمند</p>
        </div>
        <div className="d-flex justify-content-center">
          <p className="mb-2">🎧 هندزفری</p>
        </div>
        <div className="d-flex justify-content-center">
          <p className="mb-2">👕 گرمکن ورزشی</p>
        </div>
        <div className="d-flex justify-content-center">
          <p className="mb-2">🎲 بازی رومیزی</p>
        </div>
        <div className="d-flex justify-content-center">
          <p className="mb-2">🥛 ماگ جفت پوچ</p>
        </div>
      </div>
      <div className="w-100 my-3">
        <p className="font-weight-bold text-center blueColor">جوایز نهایی</p>
        <div className="d-flex justify-content-center">
          <p className="mb-2">🚲 دوچرخه</p>
        </div>
        <div className="d-flex justify-content-center">
          <p className="mb-2">💻 لب‌ تاب</p>
        </div>
        <div className="d-flex justify-content-center">
          <p className="mb-2">📱 تلفن همراه</p>
        </div>
        <div className="d-flex justify-content-center">
          <p className="mb-2">🔭 تلسکوپ</p>
        </div>
      </div>
    </>
  );

  return (
    <Modal
      open={show}
      closeHandler={handleClose}
      dialogContent={awardsDialog}
    />
  );
};

export default Awards;
